import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import { PaymentBatchProps } from "types/modals";

import "components/modals/PaymentBatch.modal.scss";

/**
 * Hosts the Autopay signing flow for a payment batch in an iframe.
 * The flow closes itself: Autopay posts a message back, which the batch component
 * handles by hiding the frame - that in turn closes this modal through the router.
 */
const PaymentBatch = ({ more }: PaymentBatchProps): React.ReactElement => {
    const { translate } = useTranslation();

    return (
        <div className="ga-modal__content payment-batch-modal">
            {more.autopayURL && (
                // tabIndex makes the frame part of the modal focus trap, so it stays keyboard reachable
                <iframe
                    title={translate("myTasks.autopayFrameTitle")}
                    className="payment-batch-modal__frame"
                    src={more.autopayURL}
                    tabIndex={0}
                />
            )}
        </div>
    );
};

export default PaymentBatch;
